export default "__VITE_ASSET__d0f45486__"